import { createApiSaga } from '../../../sagaGenerator';
import { apiDelete, apiGet, apiPatch } from '../../../../middleware/api';
import {
  RUNUP_DATA_DELETE_RUNUP_REQUEST,
  RUNUP_DATA_DELETE_RUNUP_SUCCESS,
  RUNUP_DATA_DELETE_RUNUP_FAILURE,
  RUNUP_DATA_CAUSE_REQUEST,
  RUNUP_DATA_CAUSE_SUCCESS,
  RUNUP_DATA_CAUSE_FAILURE,
  RUNUP_DATA_VALIDITY_REQUEST,
  RUNUP_DATA_VALIDITY_SUCCESS,
  RUNUP_DATA_VALIDITY_FAILURE,
  RUNUP_DATA_MEASURE_TYPE_REQUEST,
  RUNUP_DATA_MEASURE_TYPE_SUCCESS,
  RUNUP_DATA_MEASURE_TYPE_FAILURE,
  RUNUP_DATA_REGION_SUCCESS,
  RUNUP_DATA_REGION_REQUEST,
  RUNUP_DATA_REGION_FAILURE,
  RUNUP_DATA_RUNUP_REGION_SUCCESS,
  RUNUP_DATA_RUNUP_REGION_REQUEST,
  RUNUP_DATA_RUNUP_REGION_FAILURE,
  RUNUP_DATA_BULK_EDIT_REQUEST,
  RUNUP_DATA_BULK_EDIT_SUCCESS,
  RUNUP_DATA_BULK_EDIT_FAILURE,
} from './runupDataReducer';

const bulkEditRunupsSaga = createApiSaga({
  apiFunction: apiPatch,
  generateApiConfig: action => ({ endpoint: '/tsunamis/runups', ...action }),
  requestType: RUNUP_DATA_BULK_EDIT_REQUEST,
  successType: RUNUP_DATA_BULK_EDIT_SUCCESS,
  failureType: RUNUP_DATA_BULK_EDIT_FAILURE,
  successMessage: 'Saved',
});

const deleteRunupSaga = createApiSaga({
  apiFunction: apiDelete,
  generateApiConfig: action => ({ endpoint: `/tsunamis/runups/${action.id}`, ...action }),
  requestType: RUNUP_DATA_DELETE_RUNUP_REQUEST,
  successType: RUNUP_DATA_DELETE_RUNUP_SUCCESS,
  failureType: RUNUP_DATA_DELETE_RUNUP_FAILURE,
  successMessage: 'Deleted',
});

const getValiditySaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: '/descriptors/tsunami/validity', ...action }),
  requestType: RUNUP_DATA_VALIDITY_REQUEST,
  successType: RUNUP_DATA_VALIDITY_SUCCESS,
  failureType: RUNUP_DATA_VALIDITY_FAILURE,
});

const getCauseSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: '/descriptors/tsunami/causes', ...action }),
  requestType: RUNUP_DATA_CAUSE_REQUEST,
  successType: RUNUP_DATA_CAUSE_SUCCESS,
  failureType: RUNUP_DATA_CAUSE_FAILURE,
});

const getRunupMeasureTypesSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: '/descriptors/tsunami/runup/measurement-types', ...action }),
  requestType: RUNUP_DATA_MEASURE_TYPE_REQUEST,
  successType: RUNUP_DATA_MEASURE_TYPE_SUCCESS,
  failureType: RUNUP_DATA_MEASURE_TYPE_FAILURE,
});

const getRegionsSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: '/descriptors/tsunami/regions', ...action }),
  requestType: RUNUP_DATA_REGION_REQUEST,
  successType: RUNUP_DATA_REGION_SUCCESS,
  failureType: RUNUP_DATA_REGION_FAILURE,
});

const getRunupRegionsSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: '/descriptors/tsunami/runup/regions', ...action }),
  requestType: RUNUP_DATA_RUNUP_REGION_REQUEST,
  successType: RUNUP_DATA_RUNUP_REGION_SUCCESS,
  failureType: RUNUP_DATA_RUNUP_REGION_FAILURE,
});

export const runupDataSagas = [
  bulkEditRunupsSaga,
  deleteRunupSaga,
  getValiditySaga,
  getCauseSaga,
  getRunupMeasureTypesSaga,
  getRegionsSaga,
  getRunupRegionsSaga,
];
